import { createActions } from 'redux-actions'

export const {
  tracking: {
    initialSearch: trackInitialSearch,
    manualSearch: trackManualSearch,
    numResults: trackNumResults,
    contentIsLoaded: trackContentLoaded,
    disableQualifiedViewTracking,
    disableUserInteractionTracking,
    disableExtendedQualifiedViewTracking
  }
} = createActions({
  TRACKING: {
    INITIAL_SEARCH: [payload => payload, (payload, meta) => meta],
    MANUAL_SEARCH: [payload => payload, (payload, meta) => meta],
    NUM_RESULTS: [payload => payload, (payload, meta) => meta],
    CONTENT_IS_LOADED: [payload => payload, (payload, meta) => meta],
    DISABLE_QUALIFIED_VIEW_TRACKING: payload => payload,
    DISABLE_USER_INTERACTION_TRACKING: payload => payload,
    DISABLE_EXTENDED_QUALIFIED_VIEW_TRACKING: payload => payload
  }
})
